import { useQuery } from "@tanstack/react-query";
import { getProject } from "../api";

export function useProject(projectId: string) {
    return useQuery({
        queryKey: ['project', projectId],
        queryFn: () => getProject(projectId as string),
        enabled: !!projectId,
        staleTime: 60_000,              // 1분 동안은 "신선" 처리(재요청 줄이기)
        refetchOnMount: 'always',       // 캐시가 있어도 백그라운드로 최신화(선택)
    });
}
